import { render } from "./References.vue?vue&type=template&id=67ff15f0&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"

import "./References.vue?vue&type=style&index=0&id=67ff15f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ff15f0"]])

export default __exports__